import React from "react";
import { useEffect } from "react";
import { loadAlerts } from "./wpreq";
import "./AlertCard.css";

function AlertCard({ alert, index, maxIndex, currentIndex }) {

  useEffect(() => {
    console.log(alert);
  }, [alert]);

  if (index !== currentIndex) {
    return null;
  }

  return (
    <div className="alert-card" style={{ position: "relative" }}>
      <div style={{ padding: 20}}>
      <p style={{ position: "absolute", top: 20, right: 20, zIndex: 9, fontSize: "0.8rem", color: "black", margin: 0 }}>
        {index + 1} / {maxIndex}
      </p>
      <h3>
        <i className="fa-solid fa-triangle-exclamation" style={{ marginRight: "10px" }}></i>
        {alert.title.rendered}
      </h3>
      <div
        className="alert-card-content"
        style={{ fontSize: "0.9rem" }}
        dangerouslySetInnerHTML={{ __html: alert.content.rendered.substring(0, 100) }}
      />
      </div>
    </div>
  );
}

function AlertCardProvider() {

  const [ data, setData ] = React.useState(null);
  const [ currentIndex, setCurrentIndex ] = React.useState(0);

  useEffect(() => {
    loadAlerts(setData);
  }, []);

  useEffect(() => {
    if (!data) return;
    
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % data.length);
    }, 5000); // Change alert every 5 seconds

    return () => clearInterval(interval);
  }, [data]);

  if (!data) return null;

  return (
      <>

        {
            data.map((alert, index) => (
                <AlertCard alert={alert} key={alert.id} index={index} maxIndex={data.length} currentIndex={currentIndex} />
            ))
        }
        </>
    );
}

export default AlertCardProvider;